/**
 * Progress — "N of 12 to your estimate", counting to the estimate, not to
 * total questions (DESIGN-SYSTEM.md). Twelve is a finish line someone can see.
 */
interface ProgressProps {
  step: number;
  total: number;
  onBack?: () => void;
}

export function Progress({ step, total, onBack }: ProgressProps): JSX.Element {
  const pct = Math.max(0, Math.min(100, Math.round((step / total) * 100)));
  return (
    <div className="progress">
      <div className="progress__row">
        {onBack ? (
          <button type="button" className="progress__back" onClick={onBack}>
            Back
          </button>
        ) : (
          <span />
        )}
        <div className="progress__count">
          {step} of {total} to your estimate
        </div>
      </div>
      <div className="progress__bar">
        <div className="progress__fill" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
